<template>
  <div class="Comparison">
    <div class="p-title">能耗分析</div>
    <div class="p-cont">
      <div class="title row-center" style="justify-content: space-between;">
        <div class="row-center">
          <el-date-picker :editable="false" :picker-options="pickerOptions" :clearable="false" class="dateSelect"
            v-model="date" :format="radio === 'week' ? 'yyyy 第 WW 周' : ''" :type="radio === 'day' ? 'date' : radio"
            :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')">
          </el-date-picker>

          <div class="radio">
            <el-radio v-model="radio" label="year">年</el-radio>
            <el-radio v-model="radio" label="month">月</el-radio>
            <el-radio v-model="radio" label="week">周</el-radio>
            <el-radio v-model="radio" label="day">日</el-radio>
          </div>
          <el-button plain class="btn per" @click="perD" v-if="radio === 'day'">上一日</el-button>
          <el-button plain class="btn per" @click="perM" v-if="radio === 'month'">上一月</el-button>
          <el-button plain class="btn per" @click="perW" v-if="radio === 'week'">上一周</el-button>
          <el-button plain class="btn per" @click="perY" v-if="radio === 'year'">上一年</el-button>
          <el-button class="btn next" plain @click="nextD" v-if="radio === 'day'" :disabled="nextDayDisabled">下一日
          </el-button>
          <el-button class="btn next" plain @click="nextM" v-if="radio === 'month'" :disabled="nextDayDisabled">
            下一月
          </el-button>
          <el-button class="btn next" plain @click="nextW" v-if="radio === 'week'" :disabled="nextDayDisabled">
            下一周
          </el-button>
          <el-button class="btn next" plain @click="nextY" v-if="radio === 'year'" :disabled="nextDayDisabled">下一年
          </el-button>
        </div>
      </div>
      <div class="Pinnacle row-center">
        <div class="cont ">
          <div class="tabs-container">
            <span :class="isActive == '-1' ? 'active' : ''" @click="isActive = '-1'">总</span>
            <span :class="isActive == '0' ? 'active' : ''" @click="isActive = '0'">电</span>
            <span :class="isActive == '1' ? 'active' : ''" @click="isActive = '1'">水</span>
            <span :class="isActive == '2' ? 'active' : ''" @click="isActive = '2'">热</span>
            <span :class="isActive == '3' ? 'active' : ''" @click="isActive = '3'">冷</span>
          </div>
          <div v-if="!RingratioShow" class="canvasShow">
            <img class="nodata" src="@/assets/img/not_found_data.png" alt="" />
          </div>
          <div class="box" v-if="RingratioShow">
            <div class="charts" >
              <!-- <div style="height:100%" v-if="chainloading" class="newloading">
                  <Loading LoadingId="chainloading" :scale="1.2"   />
              </div> -->
              <charts id="Comparison1" :option="Comparison1"></charts>
            </div>
            <div class="right">
              <div class="p">环比增长率</div>
              <div class="pare" :class="{ 'red': chainLv > 0, 'green': chainLv <= 0 }" v-if="ratioLv != 'NaN'">
                {{ chainLv != "NaN" ? chainLv : '--' }} %<img src="@/assets/img/shang.png" v-if="chainLv > 0" /><img
                  src="@/assets/img/xia1.png" v-else />
              </div>
              <div class="pare " v-else> --%</div>
              <div class="line"></div>
              <div class="num">本期总能耗（折标煤）：{{ ChainData[1].toFixed(2) }} {{unitName}}</div>
              <div class="num">上期总能耗（折标煤）：{{ ChainData[0].toFixed(2) }} {{unitName}}</div>
              <div class="num">增长值：{{ (ChainData[1] - ChainData[0]).toFixed(2) }} {{unitName}}</div>
            </div>
          </div>
          <div class="box" v-if="RingratioShow" style="margin-top:20rem">
            <div class="charts">
              <!-- <div style="height:100%" v-if="ratioloading" class="newloading">
                  <Loading LoadingId="ratioloading" :scale="1.2"   />
              </div> -->
              <charts id="Comparison2" :option="Comparison2"></charts>

            </div>
            <div class="right">
              <div class="p">同比增长率</div>
              <div class="pare " :class="{ 'red': ratioLv > 0, 'green': ratioLv <= 0 }" v-if="ratioLv != 'NaN'">
                {{ ratioLv != "NaN" ? ratioLv : "--" }} %<img src="@/assets/img/shang.png" v-if="ratioLv > 0" /><img
                  src="@/assets/img/xia1.png" v-else />
              </div>
              <div class="pare " v-else> --% </div>
              <div class="line"></div>
              <div class="num">本期总能耗（折标煤）：{{ RatioData[1].toFixed(2) }} {{unitName}}</div>
              <div class="num">同期总能耗（折标煤）：{{ RatioData[0].toFixed(2) }} {{unitName}}</div>
              <div class="num">增长值：{{ (RatioData[1] - RatioData[0]).toFixed(2) }} {{unitName}}</div>
            </div>
          </div>
        </div>
        <div class="chart-right">
          <div class="tag row-center">
            <span :class="{ active: type == '0' }" @click="type = '0'">分类能耗对比</span>
            <span :class="{ active: type == '1' }" @click="type = '1'">分项能耗对比</span>
          </div>
          <div class="chart" v-if="type == 0">
            <!-- v-loading="Classificationloading1" -->
            <charts id="Classification1" :option="Classification1" ></charts>
          </div>
          <div class="chart" v-if="type == 1">
            <!-- v-loading="Classificationloading2" -->
            <charts id="Classification2" :option="Classification2" ></charts>
          </div>
          <div class="standard" v-if="type == 0">
            折煤标：<span>{{ zbmNumber }} tce</span>
          </div>
          <div class="energyused" v-if="type == 0">
            <span>用电量：{{ Number(energyRatio.power).toFixed(2) }} kWh</span>
            <span>用热量：{{ Number(energyRatio.heat).toFixed(2) }} GJ</span>
            <span>用水量：{{ Number(energyRatio.water).toFixed(2) }} m³</span>
            <span>用冷量：{{ Number(energyRatio.cooling).toFixed(2) }} GJ</span>
          </div>
          <div class="energyused" v-if="type == 1">
            <span>空调：{{ Number(energySubitem['空调']).toFixed(2) }} kWh</span>
            <span>照明：{{ Number(energySubitem['照明']).toFixed(2) }} kWh</span>
            <span>动力：{{ Number(energySubitem['动力']).toFixed(2) }} kWh</span>
            <span>特殊：{{ Number(energySubitem['特殊']).toFixed(2) }} kWh</span>
          </div>
        </div>
      </div>
      <div class="ComparisonData">
        <div class="title">
          <div class="tagleft">
            <div class="item" @click="tagarea = 0" :class="{ active: tagarea == 0 }">
              <span>分类能耗对比·电</span>
              <!-- <el-dropdown trigger="click" @command="handleCommand" style="vertical-align: -2px">
                <span class="el-dropdown-link">
                  <label for="">{{ downval
                  }}<img src="@/assets/img/bottom_selected.png" alt="" /></label>
                </span>
                <el-dropdown-menu slot="dropdown" style="width:6vw">
                  <el-dropdown-item v-for="item in downlist" :command="item">{{
                      item.label
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
            <div class="item" @click="tagarea = 1" :class="{ active: tagarea == 1 }" v-if="projectType=='2'">
              分项能耗对比
            </div>
          </div>
          <div class="right">
            <div class="area" @click.stop="listShow = !listShow; listShow1 = false">
              <span>对象一：{{ currentLoop.name }}</span><img src="@/assets/img/change0.png" alt="" />
              <div @click.stop="" ref="area">
                <Zone v-if="listShow" @closedArea="closedArea" @getcurrentLoop="getcurrentLoop"
                  :currentLoop="currentLoop" ></Zone>
              </div>
            </div>
            <div class="area" @click.stop="listShow1 = !listShow1; listShow = false">
              <span>对象二：{{ currentLoop1.name }}</span><img src="@/assets/img/change0.png" alt="" />
              <div @click.stop="" ref="area1">
                <Zone v-if="listShow1" @closedArea="closedArea1" @getcurrentLoop="getcurrentLoop1"
                  :currentLoop="currentLoop1"></Zone>
              </div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div class="box" v-if="tagarea == 0">
            <div class="tt">
              <!-- <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  分类能耗对比·<label for="">{{ downval
                  }}<img src="@/assets/img/bottom_selected.png" alt="" /></label>
                </span>
                <el-dropdown-menu slot="dropdown" style="width:6vw">
                  <el-dropdown-item v-for="item in downlist" :command="item">{{
                    item.label
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <el-checkbox v-model="showMax" @change="showMaxChange">最值分析</el-checkbox>
            </div>
            <!-- v-loading="loading" -->
            <div  class="echarts row-center" style="justify-content: space-between"
              :class="{ showMax }">
              <div class="left" style="height:26vh;text-align: center;">
                <Curve v-if="diagramData && canvasShow&&node=='electricity'" :chartsData="diagramData"></Curve>
                <img class="nodata" v-else src="@/assets/img/not_found_data.png" alt="" />
              </div>

              <div v-show="showMax" class="max-right row-center" style="justify-content: space-between"
                v-if="diagramData && canvasShow&&node=='electricity'">
                <div class="row-max" v-for="(item, index) in diagramData.legend.data" :key="index">
                  <div class="max-name u-line-1">{{ item }}</div>
                  <div class="details column-center" style="justify-content: space-evenly">
                    <div class="row-center" style="width: 100%; justify-content: flex-start">
                      <span>最大值</span><span>{{ max(item) }}</span><span></span>
                    </div>
                    <div class="row-center" style="width: 100%; justify-content: flex-start">
                      <span>最小值</span><span>{{ min(item) }}</span><span></span>
                    </div>
                    <div class="row-center" style="width: 100%; justify-content: flex-start">
                      <span>平均值</span><span>{{ average(item) }}</span><span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box" v-else>
            <!-- <div class="tt">分项能耗对比</div> -->
            <!-- v-loading="Itemloading" -->
            <div class="" style="height:26vh;text-align:center" >
              <charts id="Comparison" :option="Comparison" v-if="this.ComparisonData.seriesData"></charts>
              <img class="nodata" v-else src="@/assets/img/not_found_data.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import charts from "../../components/common/Charts.vue";
import Zone from "./components/Zone.vue";
import {
  classifiedEnergyConsumption,
  ProjectItemEnergy,
  ProjectCompareClassifiedPower,
  ProjectConsumption,
  BuildingItemEnergy,
  treeBuilding,
  GET_AREAS,
  classifiedEnergyConsumptionOfArea,
  compareClassifiedPower,
  consumerAnalysisItemLoopTree,
  LOOP_DIAGRAM_DATA_BY_DAY,
  projectLoopEnergy
} from "../../api/power";
import { floatFormat } from "../../util/MathUtil";
import Loading from '../../components/common/Loading.vue'
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  dateToString,
  dayStart,
  dayEnd,
  addDay,
  getAppointedDate,
  getDiffDate,
  weekStart,
  weekEnd,
} from "../../util/DateUtil";
import Curve from "./components/Curve";
export default {
  components: {
    charts,
    Zone,
    Curve,
    Loading
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      radio: "day",
      listShow: false,
      listShow1: false,
      showMax: true,
      downval: "电",
      node: "electricity",
      downlist: [
        {
          value: "electricity",
          unit: "kWh",
          label: "电",
        },
        {
          value: "water",
          unit: "m³",
          label: "水",
        },
        {
          value: "heat",
          unit: "GJ",
          label: "热",
        },
        {
          value: "cooling",
          unit: "GJ",
          label: "冷",
        },
      ],
      currentLoop: {},
      currentLoop1: {},
      loops: [],
      diagramData: null,
      canvasShow: true,
      loading: true,
      Itemloading: true,
      ComparisonData: {},
      unit: "kWh",
      RingratioShow: true,
      isActive: "-1",
      ChainData: [0, 0],
      RatioData: [0, 0],
      chainloading: true,
      ratioloading: true,

      energyRatio: [],
      energySubitem: [],
      ClassData1: {
        powerSC: 0,
        heatSC: 0,
        coolingSC: 0,
        waterSC: 0,
      },
      ClassData2: [],
      zbmNumber: 0,
      Classificationloading1: false,
      Classificationloading2: false,
      type: 1,
      tagarea: 0
    };
  },
  computed: {
    
    projectId(){
        return this.$store.getters.projectId
    },
    Classification1() {
      return {
        color: ["#f6bd16", "#6dc8ec", "#E8684A", "#9270CA", "#6DC8EC"],
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return `${params.marker} ${params.name}: <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> tce</b>`
          }
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            label: {
              formatter: "{name|{b}}\n{time|{d} %}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 25,
              fontSize: "16rem",
              fontWeight: 800,
              fontWeight: "bold",
              rich: {
                time: {
                  fontSize: "16rem",
                  color: "#0D94FF",
                  fontWeight: "bold",
                },
                name: {
                  fontSize: "16rem",
                  fontWeight: "bold",
                },
              },
            },
            itemStyle: {
              // 此配置
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
              },
            },
            labelLine: {
              show: true,
              lineStyle: {
                width: 2,
              },
            },
            data: [
              { value: this.ClassData1.powerSC ? this.ClassData1.powerSC.toFixed(2) : 0, name: "电" },
              // { value: this.ClassData1.heatSC?this.ClassData1.heatSC.toFixed(2):0, name: "热" },
              // { value: this.ClassData1.coolingSC?this.ClassData1.coolingSC.toFixed(2):0, name: "冷" },
              { value: this.ClassData1.waterSC ? this.ClassData1.waterSC.toFixed(2) : 0, name: "水" },
            ],
          },
        ],
      };
    },
    Classification2() {
      return {
        color: ["#f6bd16", "#6dc8ec", "#e8684a", "#9270ca"],
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return `${params.marker} ${params.name}: <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> kWh</b>`
          }
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            label: {
              formatter:function(item){
                let percent  = item.percent?item.percent:0;
                return item.name+"\n{time|"+percent+" %}"
              },
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 25,
              fontSize: "16rem",
              fontWeight: "800",
              rich: {
                time: {
                  fontSize: "16rem",
                  color: "#0D94FF",
                  fontWeight: "800",
                },
                name: {
                  fontSize: "16rem",
                  fontWeight: "bold",
                },
              },
            },
            itemStyle: {
              // 此配置
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
              },
            },
            labelLine: {
              show: true,
              lineStyle: {
                width: 2,
              },
            },
            data: this.ClassData2
          },
        ],
      };
    },
    ratioLv() {
      if (this.RatioData[0] == 0) {
        return 100
      } else {
        return ((this.RatioData[1] - this.RatioData[0]) / this.RatioData[0] * 100).toFixed(2)
      }

    },
    chainLv() {
      if (this.ChainData[0] != 0) {
        return ((this.ChainData[1] - this.ChainData[0]) / this.ChainData[0] * 100).toFixed(2)
      } else {
        return 100
      }
    },
    NodeRatio() {
      switch (this.isActive) {
        case "-1":
          return ""
          break;
        case "0":
          return "ELECTRICITY"
          break;
        case "1":
          return "WATER"
          break;
        case "2":
          return "HEAT"
          break;
        case "3":
          return "COOLING"
          break;
      }
    },
    unitName() {
      switch (this.isActive) {
        case "-1":
          return "tce"
          break;
        case "0":
          return "kWh"
          break;
        case "1":
          return "m³"
          break;
        case "2":
          return "GJ"
          break;
        case "3":
          return "GJ"
          break;
      }
    },
    updateTimeData() {
      return [
        this.date,
        this.range,
      ]
    },
    propsData() {
      return [
        this.date,
        this.range,
        this.NodeRatio
      ]
    },
    Comparison1() {
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: "item",
          position: "top",
          formatter: function (params) {
            return `${params.marker} ${params.name}: <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> tce</b>`
          },
        },
        title: {
          text: this.unitName,
          textAlign:"left",
          left: -5,// 距离左边位置
          // top: -5,// 距离上面位置
          textStyle:{
            align:"left",
            fontWeight:'bold',
            fontSize:12,
            color: "#333",
            fontStyle:'italic'
          }
        },
        grid: {
          left: "0%",
          right: "5%",
          bottom: "0%",
          top: "28px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["本期", "上期"],
          axisLabel:{
              fontSize:12,
              color: "#333",
              fontWeight:'bold'
          }
        },
        yAxis: {
          type: "value",
          // name: "tce",
          nameTextStyle: {
              align: "right",
              fontWeight:'bold',
              fontStyle:"italic",
              // fontSize: 16,
              color: "#333",
          },
          splitLine:{
              show:true,
              lineStyle:{
                  type:'dashed',
              }
          },
          axisLabel:{
              fontSize:12,
              color: "#333",
              fontWeight:'bold'
          }
        },
        series: [
          {
            name: "本期",
            type: "bar",
            barWidth: 80,
            data: [Number(this.ChainData[1]).toFixed(2), "-"],
            stack: "Total",
            itemStyle: {
              color: "#0D94FF",
            },
          },
          {
            name: "上期",
            type: "bar",
            barWidth: 80,
            data: ["-", Number(this.ChainData[0]).toFixed(2)],
            stack: "Total",
            itemStyle: {
              color: "#5AD8A6",
            },
          },
        ],
      }
    },
    Comparison2() {
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: "item",
          position: "top",
          formatter: function (params) {
            return `${params.marker} ${params.name}: <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> tce</b>`
          },
        },
        grid: {
          left: "0%",
          right: "5%",
          bottom: "0%",
          top: "28px",
          containLabel: true,
        },
        
        title: {
          text: 'tce',
          textAlign:"left",
          left: -5,// 距离左边位置
          // top: -5,// 距离上面位置
          textStyle:{
            align:"left",
            fontWeight:'bold',
            fontSize:12,
            color: "#333",
            fontStyle:'italic'
          }
        },
        xAxis: {
          type: "category",
          data: ["本期", "同期"],
          axisLabel:{
              fontSize:12,
              color: "#333",
              fontWeight:'bold'
          }
        },
        yAxis: {
          type: "value",
          // name: "tce",
          nameTextStyle: {
              align: "right",
              fontWeight:'bold',
              fontStyle:"italic",
              // fontSize: 16,
              color: "#333",
          },
          splitLine:{
              show:true,
              lineStyle:{
                  type:'dashed',
              }
          },
          axisLabel:{
              fontSize:12,
              color: "#333",
              fontWeight:'bold'
          }
        },
        series: [
          {
            name: "本期",
            type: "bar",
            barWidth: 80,
            data: [Number(this.RatioData[1]).toFixed(2), "-"],
            stack: "Total",
            itemStyle: {
              color: "#0D94FF",
            },
          },
          {
            name: "同期",
            type: "bar",
            barWidth: 80,
            data: ["-", Number(this.RatioData[0]).toFixed(2)],
            stack: "Total",
            itemStyle: {
              color: "#5AD8A6",
            },
          },
        ],
      }
    },
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      } else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
    changeData() {
      return [this.date, this.node, this.currentLoop, this.currentLoop1];
    },
    changeFxData() {
      return [this.date, this.currentLoop, this.currentLoop1];
    },
    //最小值
    min() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (
          data[0].data.length === 0 ||
          data[0].data.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let minValue = Math.min(...data[0].data);
        let minTimeIndex = data[0].data.findIndex((item) => item == minValue);
        let minTime = this.diagramData.xAxis.data[minTimeIndex];
        return (
          floatFormat(Math.min(...data[0].data), 2) +
          ` (${this.formateTime(minTime)})`
        );
      };
    },
    //平均值
    average() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (
          data[0].data.length === 0 ||
          data[0].data.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let sum = 0;
        data[0].data.forEach((e) => (sum += +e));
        return floatFormat(sum / data[0].data.length, 2);
      };
    },
    //最大值
    max() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (
          data[0].data.length === 0 ||
          data[0].data.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let maxValue = Math.max(...data[0].data);
        let maxTimeIndex = data[0].data.findIndex((item) => item == maxValue);
        let maxTime = this.diagramData.xAxis.data[maxTimeIndex];
        return (
          floatFormat(Math.max(...data[0].data), 2) +
          ` (${this.formateTime(maxTime)})`
        );
      };
    },
    Comparison() {
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: "#333333", //设置文字颜色
            align:"left"
          },
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
                str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data}</b><b style='font-size:14px;'> kWh</b>`;
                str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: 14,
          },
          itemGap: 50,
        },
        
        title: {
          text: 'kWh',
          textAlign:"left",
          left: -5,// 距离左边位置
          // top: -5,// 距离上面位置
          textStyle:{
            align:"left",
            fontWeight:'bold',
            fontSize:12,
            color: "#333",
            fontStyle:'italic'
          }
        },
        grid: {
          left: 0,
          right: 20,
          top:"15%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["空调", "照明", "动力"],
          
          axisLabel:{
              fontSize:12,
              color: "#333",
              fontWeight:'bold'
          }
        },
        yAxis: {
          type: "value",
          // name: "kWh",
          nameTextStyle: {
              align: "right",
              fontWeight:'bold',
              fontStyle:"italic",
              // fontSize: 16,
              color: "#333",
          },
          splitLine:{
              show:true,
              lineStyle:{
                  type:'dashed',
              }
          },
          axisLabel:{
              fontSize:12,
              color: "#333",
              fontWeight:'bold'
          }
        },
        series: this.ComparisonData.seriesData,
      };
    },
    projectType() {  //1-配电,2-楼栋
        return this.$store.getters.selProjectInfo.projectType;
    },
  },
  watch: {
    updateTimeData() {
      this.EnergyContrast();
      this.getBuildingConsumption();
    },
    propsData() {
      if(this.isActive=='-1'){
        this.GetCompareChain();
        this.GetCompareRatio();
      }else{
        this.GetCompareChainVar();
        this.GetCompareRatioVar();
      }

    },
    changeData() {
      this.canvasDataRult();
    },
    changeFxData() {
      this.EnergyConsumption();
    },
    currentLoop() {
      this.listShow = false;
    },
    currentLoop1() {
      this.listShow1 = false;
    },
    radio(n) {
      this.date = new Date();
      this.getBuildingConsumption();

    },

    showMax(n, o) {
      this.reload();
      // this.EnergyConsumption();
    },
  },

  beforeDestroy() {
    document.removeEventListener("click", this.closePopover);
    document.removeEventListener("click", this.closePopover1);
  },
  mounted() {
    document.addEventListener("click", this.closePopover);
    document.addEventListener("click", this.closePopover1);
    this.GetCompareChain();
    this.GetCompareRatio();
    this.EnergyContrast()
    this.getBuildingConsumption()
    this.GetreeBuilding();
  },
  methods: {
    showMaxChange(){
      this.canvasDataRult();
    },
    //分项能耗对比
    async EnergyContrast() {
      this.Classificationloading2 = true
      let range = this.radio;
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
        itemType: "",
        range: range.toUpperCase(),
      };
      let response = await ProjectItemEnergy(obj)
      
      let data = response.data.data.result
      this.ClassData2 = []
      for (let item in data) {
        this.ClassData2.push({ value: Number(data[item].toFixed(2)), name: item })
      }
      this.energySubitem = data
      this.Classificationloading2 = false
    },
    //分类能耗占比
    async getBuildingConsumption() {
      this.Classificationloading1 = true
      let range = this.radio;
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
        powerType: "",
        range: range.toUpperCase(),
      };
      let response = await ProjectConsumption(obj)
      let data = response.data.data.result
      this.ClassData1 = data
      this.energyRatio = data
      this.zbmNumber = (
        data.powerSC +
        data.heatSC +
        data.waterSC +
        data.coolingSC
      ).toFixed(2)
      this.Classificationloading1 = false
    },
    //环比
    async GetCompareChain() {
      this.chainloading = true
      let range = this.radio;
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        compareType: "ALTERNATE",
        date: dateFormat("YY-mm-dd", this.date) + 'T00:00:00Z',
        dateRange: range.toUpperCase(),
        powerType: this.NodeRatio,
      }
      let response = await ProjectCompareClassifiedPower(obj);
      this.ChainData = response.data.data.data[0];
      if (this.ChainData.filter(e => e != 0).length <= 0) {
        this.RingratioShow = false
      } else {
        this.RingratioShow = true
      }
      this.chainloading = false
    },
    
    //环比1
    async GetCompareChainVar() {
      this.chainloading = true
      let range = this.radio;
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        compareType: "ALTERNATE",
        date: dateFormat("YY-mm-dd", this.date) + 'T00:00:00Z',
        dateRange: range.toUpperCase(),
        powerType: this.NodeRatio,
      }
      let response = await compareClassifiedPower(obj);
      this.ChainData = response.data.data.data[0];
      if (this.ChainData.filter(e => e != 0).length <= 0) {
        this.RingratioShow = false
      } else {
        this.RingratioShow = true
      }
      this.chainloading = false
    },
    //同比
    async GetCompareRatio() {
      this.ratioloading = true
      let range = this.radio;
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        compareType: "SEPARATED",
        date: dateFormat("YY-mm-dd", this.date) + 'T00:00:00Z',
        dateRange: range.toUpperCase(),
        powerType: this.NodeRatio,
      }
      let response = await ProjectCompareClassifiedPower(obj);
      this.RatioData = response.data.data.data[0];
      this.ratioloading = false
    },
    //同比
    async GetCompareRatioVar() {
      this.ratioloading = true
      let range = this.radio;
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        compareType: "SEPARATED",
        date: dateFormat("YY-mm-dd", this.date) + 'T00:00:00Z',
        dateRange: range.toUpperCase(),
        powerType: this.NodeRatio,
      }
      let response = await compareClassifiedPower(obj);
      this.RatioData = response.data.data.data[0];
      this.ratioloading = false
    },
    //分类能耗对比
    EnergyConsumption() {
      this.Itemloading = true;
      let range = this.radio;
      let node = this.node;
      let promises = [];
      let currList = [this.currentLoop, this.currentLoop1];

      currList.forEach((element) => {
        let obj = {
          buildingId: element.id,
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          itemType: "",
          range: range.toUpperCase(),
        };
        promises.push(BuildingItemEnergy(obj));
      });

      Promise.all(promises).then((res) => {
        let pointsArray = res.map((r) =>
          r.data.data.result ? r.data.data.result : {}
        );
        let seriesData = [];
        let legendTitle = [];
        let num = 0;
        let markPoint;
          if(this.showMax){
              markPoint = {
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],

              symbol: "pin",
              symbolSize: "20",
              label: {
                position: "top",
              },
            }
          }
        pointsArray.forEach((item, index) => {
          let data = [];
          for (let i in item) {
            data.push(item[i].toFixed(2));
          }
          let name = ["对象一：", "对象二："]
          legendTitle.push(name[index] + currList[index].name);
          seriesData.push({
            name: name[index] + currList[index].name,
            type: "bar",
            barWidth: 80,
            data: data
          });
        });
        this.Itemloading = false;
        this.ComparisonData = {
          seriesData: seriesData,
          legendTitle: legendTitle,
        };
      });
    },
    formateTime(string) {
      let array = string.split("");
      array.pop();
      if (array.length < 2) {
        return "0" + array[0] + ":00";
      } else {
        return array.join("") + ":00";
      }
    },
    reload() {
      this.canvasShow = !this.canvasShow;
      this.$nextTick(() => {
        this.canvasShow = !this.canvasShow;
      });
    },
    //楼栋
    GetreeBuilding() {
      if(this.projectType==1){
        let range = this.radio;
        let obj = {
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          projectId: this.$store.getters.projectId,
          range: range.toUpperCase(),
        }
        consumerAnalysisItemLoopTree(obj).then((res) => {
          res.data.data.forEach(element => {
            element.deviceLoops.forEach(elm=>{
              elm.name = elm.loopName
            })
          });
          this.loops = res.data.data
          if(this.$store.getters.projectId==13){
            this.currentLoop = this.loops[0].deviceLoops[0];
            this.currentLoop1 = this.loops[0].deviceLoops[1];

          }else{
            this.currentLoop = this.loops[1].deviceLoops[0];
            this.currentLoop1 = this.loops[1].deviceLoops[1];
          }
        })

        // GET_AREAS().then((res) => {
        //   if(res.data.status){
        //     this.loops = res.data.data.areas.map(e=>{e.name=e.areaName;e.id=e.areaId;return e})
        //     this.currentLoop = this.loops[0];
        //     if(this.projectId==18||this.projectId==4){
        //       this.currentLoop1 = this.loops[0];
        //     }else{
        //       this.currentLoop1 = this.loops[1];
        //     }
        //     this.canvasDataRult();
        //     this.EnergyConsumption();
        //   }else{
        //     this.canvasShow = false
        //     this.loading = false
        //     this.Itemloading = false
        //   }
        //   // this.currentLoop = this.treeData[0]
        // });
      }else{
        treeBuilding().then((res) => {
          if(res.data.status){
            this.loops = res.data.data.tree;
            this.currentLoop = this.loops[0];
            this.currentLoop1 = this.loops[0].children[0];
            this.canvasDataRult();
            this.EnergyConsumption();
          }else{
            this.canvasShow = false
            this.loading = false
            this.Itemloading = false
          }
        });
      }
      
    },
    //分类能耗对比
    canvasDataRult() {
      this.loading = true;
      let range = this.radio;
      let node = this.node;
      let promises = [];
      let xAxisData = [];
      if (this.radio == "year") {
        for (let i = 1; i <= 12; i++) {
          xAxisData.push(i + "月");
        }
      } else if (this.radio == "month") {
        for (let i = 1; i <= 31; i++) {
          xAxisData.push(i + "日");
        }
      } else if (this.radio == "week") {
        let startDate = weekStart(this.date).replace("T00:00:00Z", "");
        let endDate = weekEnd(this.date).replace("T00:00:00Z", "");
        let time = getDiffDate(startDate, endDate);
        for (let i = 0; i < time.length; i++) {
          xAxisData.push(time[i]);
        }
      } else if (this.radio == "day") {
        for (let i = 0; i < 24; i++) {
          xAxisData.push(i + "点");
        }
      }
      let currList = [this.currentLoop, this.currentLoop1];
      if(this.projectType==1){
        currList.forEach((element) => {
          // let obj = {
          //   areaId: element.id,
          //   date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          //   powerType: node.toUpperCase(),
          //   range: range.toUpperCase(),
          // };
          // promises.push(classifiedEnergyConsumptionOfArea(obj));
          let obj = {
            areaId: element.id,
            date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
            powerType: node.toUpperCase(),
            range: range.toUpperCase(),
          };
          // promises.push(LOOP_DIAGRAM_DATA_BY_DAY(element.loopId,'PA_total',this.date));
          let obj1 = {
            deviceLoopId: element.loopId,
            projectId: this.$store.state.project.currentProject.projectId,
            date:dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
            dateRange:range.toUpperCase()
          }
          promises.push(projectLoopEnergy(obj1));
        });

          
        Promise.all(promises).then((res) => {
          let pointsArray = res.map((r) =>
            r.data.data.data ? r.data.data.data : []
          );
          let seriesData = [];
          let legendTitle = [];
          let num = 0;
          let name = ["对象一：", "对象二："]
          let markPoint;
          if(this.showMax){
              markPoint = {
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],

              symbol: "pin",
              symbolSize: "20",
              label: {
                position: "top",
              },
            }
          }
          pointsArray.forEach((item, index) => {
            let data = item.map((e) => {
              return e == null ? "" : Number(e).toFixed(2);
            })
            seriesData.push({
              data: data,
              type: "line",
              name: name[index] + currList[index].name,
              smooth: true,
              markPoint,
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: index == 0 ? 'rgba(13, 148, 255, 0.8)' : 'rgba(90, 216, 166, 0.8)' // 0% 处的颜色
                  }, {
                    offset: 1, color: index == 0 ? 'rgba(13, 148, 255, 0)' : 'rgba(90, 216, 166, 0)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            });
            legendTitle.push(name[index] + currList[index].name);
            if (data.filter(e => e != 0).length <= 0) {
              num++;
            }
          });
          this.loading = false;
          if (num >= 2) {
            this.canvasShow = false;
            this.diagramData = false;
            return;
          } else {
            this.canvasShow = true;
          }
          this.$set(
            this,
            "diagramData",
            this.createCanvasData(legendTitle, xAxisData, seriesData)
          );
        });
      
      }else{
        currList.forEach((element) => {
          let obj = {
            buildingId: element.id,
            date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
            powerType: node.toUpperCase(),
            range: range.toUpperCase(),
          };
          promises.push(classifiedEnergyConsumption(obj));
        });
          
        Promise.all(promises).then((res) => {
          let pointsArray = res.map((r) =>
            r.data.data.result ? r.data.data.result : []
          );
          let seriesData = [];
          let legendTitle = [];
          let num = 0;
          let name = ["对象一：", "对象二："]
          let markPoint;
          if(this.showMax){
              markPoint = {
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],

              symbol: "pin",
              symbolSize: "20",
              label: {
                position: "top",
              },
            }
          }
          pointsArray.forEach((item, index) => {
            let data = item[node]
              .map((e) => {
                return e == null ? "" : e.toFixed(2);
              })
            seriesData.push({
              data: data,
              type: "line",
              name: name[index] + currList[index].name,
              smooth: true,
              markPoint,
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: index == 0 ? 'rgba(13, 148, 255, 0.8)' : 'rgba(90, 216, 166, 0.8)' // 0% 处的颜色
                  }, {
                    offset: 1, color: index == 0 ? 'rgba(13, 148, 255, 0)' : 'rgba(90, 216, 166, 0)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            });
            legendTitle.push(name[index] + currList[index].name);
            if (data.filter(e => e != 0).length <= 0) {
              num++;
            }
          });
          this.loading = false;
          if (num >= 2) {
            this.canvasShow = false;
            this.diagramData = false;
            return;
          } else {
            this.canvasShow = true;
          }
          this.$set(
            this,
            "diagramData",
            this.createCanvasData(legendTitle, xAxisData, seriesData)
          );
        });
      
      }
      

    
    },
    createCanvasData(legendTitle, xAxisData, seriesData) {
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            color: "#333333", //设置文字颜色
            align: 'left'
          },
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
                str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data}</b><b style='font-size:14px;'> kWh</b>`;
                str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: 14,
          },
          itemGap: 50,
          data: legendTitle,
        },
        grid: {
          left: 20,
          right: 20,
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
        },
        yAxis: {
          type: "value",
          name: this.unit,
        },
        series: seriesData,
      };
    },
    getcurrentLoop(val) {
      this.currentLoop = val;
    },
    getcurrentLoop1(val) {
      this.currentLoop1 = val;
    },
    handleCommand(command) {
      this.downval = command.label;
      this.node = command.value;
      this.unit = command.unit;
    },
    closePopover(e) {
      let self = this;
      if (self.$refs.area && !self.$refs.area.contains(e.target)) {
        if (self.listShow == true) {
          self.listShow = false;
        }
      }
    },
    closePopover1(e) {
      let self = this;
      if (self.$refs.area1 && !self.$refs.area1.contains(e.target)) {
        if (self.listShow1 == true) {
          self.listShow1 = false;
        }
      }
    },
    closedArea() {
      this.listShow = false;
    },
    closedArea1() {
      this.listShow1 = false;
    },
    perW() {
      let week = getAppointedDate(this.date, 1, 1);
      this.date = new Date(week.startDate);
    },
    nextW() {
      let week = getAppointedDate(this.date, 1, -1);
      this.date = new Date(week.startDate);
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
  },
};
</script>

<style scoped lang="less">
.Comparison {
  height: 100%;
  font-size: 18rem;
  width: 100%;

  .p-title {
    font-size: 18rem;
    font-weight: bold;
    height: 50rem;
    line-height: 50rem;
    width: 100%;
  }

  .p-cont {
    height: calc(100% - 50rem);
    width: 100%;
    overflow-y: auto;
    padding:0 20rem;
    justify-content: space-between;
    background-color: #ffffff;
  }

  .Pinnacle {
    justify-content: space-between;
    // margin: 0 20rem;
    // overflow: hidden;
    align-items: flex-start;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    // margin-bottom: 20rem;
    padding-bottom: 20rem;

    .canvasShow {
      text-align: center;
      // display: flex;
      // height: 100%;
      // align-items: center;
      // justify-content: center;
      padding-top: 8vh;
    }

    .tabs-container {
      display: flex;
      flex-direction: row;
      justify-content: space-left;

      span {
        line-height: 40rem;
        border-top: 2px solid #fff;
        font-size: 16rem;
        font-weight: 400;
        margin: 0 10rem;
        cursor: pointer;
        font-weight: bold;
      }

      .active {
        color: #0d94ff;
        border-top: 2px solid #0d94ff;
      }
    }

    .chart-right {
      .w(392);
      height: 100%;

      .chart {
        .h(220);
        margin: 20rem 0;
      }

      .tag {
        justify-content: space-between;
        text-align: center;

        span {
          width: 45%;
          height: 33px;
          background: #F0F3F6;
          border-radius: 16px;
          line-height: 33px;
          font-size: 16px;
          display: inline-block;
          text-align: center;
          cursor: pointer;
        }

        .active {
          background: rgba(13, 148, 255, 0.16);
          color: #0D94FF;
        }
      }

      .standard {
        background: rgba(0, 43, 102, 0.04);
        border-radius: 4rem;
        height: 48rem;
        line-height: 48rem;
        text-align: center;

        span {
          font-size: 18rem;
          font-weight: bold;
          color: #0D94FF;
        }
      }

      .energyused {
        text-align: center;
        text-align: center;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: center;
        margin-top: -5rem;

        span {
          display: inline-block;
          background: rgba(0, 43, 102, 0.04);
          border-radius: 4rem;
          height: 4vh;
          width: 49%;
          margin-top: 10rem;
          line-height: 4vh;
          text-align: center;
          font-size: 16rem;
          color: #666666;
        }
      }
    }

    .cont {
      // height: 80vh;
      // width: 60%;
      .w(740);
      height: 100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 12px 0px rgba(8, 1, 3, 0.04);
      padding: 0 15px 10px 15px;
      position: relative;
      z-index: 9;
      // padding: 0 20rem 20rem 20rem;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;

      //   align-items: center;
      .tt {
        font-size: 18rem;
        font-weight: bold;
        height: 8vh;
      }

      .box {
        .h(189);
        background: rgba(0, 43, 102, 0.04);
        border-radius: 12rem;
        width: 100%;
        padding: 10rem 20rem 5px 20rem;
        // margin-bottom: 20rem;
        display: flex;

        .charts {
          width: 65%;
          height: 100%;
          position: relative;
        }

        .right {
          padding-left: 1vw;
          font-weight: bold;
          width: 35%;
          position: relative;

          .p {
            font-size: 14rem;
            font-weight: bold;
          }

          .pare {
            font-size: 26rem;
            margin-top: 10rem;
            font-family: Source Han Sans CN;

            img {
              height: 16rem;
              margin-left: 10rem;
            }
          }

          .red {
            color: #fc2e32;
          }

          .green {
            color: #38ad6c;
          }

          .line {
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            margin-top: 12rem;
            margin-bottom: 12rem;
            position: relative;

            &:before {
              content: "";
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background: rgba(0, 0, 0, 0.15);
              position: absolute;
              display: inline-block;
              margin-top: -4px;
              margin-left: -7px;
            }
          }

          .num {
            font-size: 12rem;
            line-height: 27rem;
            font-weight: 400;
          }
        }
      }
    }
  }

  .title {
    height: 8vh;
    // padding: 0 20rem;
    width: 100%;

    .demonstration {
      margin-right: 10rem;
    }

    .block {
      margin-right: 80rem;
    }

    .dateSelect {
      margin-right: 10rem;
    }

    .per {
      margin-left: 10rem;
    }

    .el-radio {
      margin-right: 20rem;
    }

    .area {
      height: 3.5vh;
      width: 260rem;
      line-height: 3.5vh;
      background: #eeeeee;
      border-radius: 18rem;
      padding: 0 20rem;
      display: inline-block;
      margin: 0 10rem;
      float: left;
      cursor: pointer;
      position: relative;
      font-size: 16rem;

      span {
        max-width: 188rem;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      img {
        float: right;
        margin-top: 1vh;
      }
    }
  }

  .ComparisonData {
    .title {
      height: 5vh;

      .tagleft {
        float: left;

        .item {
          display: inline-block;
          font-size: 16rem;
          font-weight: bold;
          float: left;
          margin-right: 30px;
          padding-top: 15px;
          margin-top: -1px;
          cursor: pointer;

          span {
            font-size: 16rem;
            color: #333;
            float: left;
            cursor: pointer;

            label {
              cursor: pointer;
            }

            img {
              // vertical-align: middle;
              margin-left: 5px;
            }
          }
        }

        .active {
          border-top: 2px solid #0D94FF;
            span{
              color:#0D94FF;
            }
        }
      }

      .right {
        float: right;
        margin-top: 10px;
      }
    }

    .showMax {
      div.left {
        .w(900) !important
      }
    }

    .echarts {
      width: 100%;
      align-items: flex-end;

      .left {
        width: 100%;
      }

      .max-right {
        .w(222);
        // .h(340);
        height:100%;
        margin-right: 24rem;

        .row-max {
          width: 100%;
          background-color: rgba(0, 43, 102, 0.02);
          // height: 88px;
          margin-top: 10px;
          padding: 10rem;
          border-radius: 4rem;

          .details {
            // .w(185);
            height: 100%;
            // padding: 12rem 0;

            span {
              margin-right: 8rem;
              color: rgba(13, 148, 255, 1);
              font-size: 16rem;

              &:first-child {
                color: #333333;
              }
            }
          }

          .max-name {
            height: 100%;
            // .w(96);
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
          }
        }
      }
    }

    .nodata {
      text-align: center;
      margin-top: 20px;
    }


    .cont {
      width: 100%;

      .box {
        //height: 49%;
        //.h(300);
        width: 100%;
        margin-top: 20rem;
        // padding: 20rem;
        position: relative;

        .tt {
          font-size: 16rem;
          font-weight: bold;
          position: absolute;
          right: 40px;
          z-index: 99;
          // top: 20px;
          // height: 5vh;

          span {
            font-size: 16rem;
            color: #333;
            float: left;
            cursor: pointer;

            label {
              cursor: pointer;
            }

            img {
              // vertical-align: middle;
              margin-left: 5px;
            }
          }
        }
      }

    }

  }
}

.el-dropdown-menu {
  text-align: center;
}
</style>
